import Vue from 'vue'

export async function getReparaciones(context, [access_token]) {
    try {
        if (access_token) {
            context.commit('setLoading', true, { root: true })
            const response = await Vue.axios({
                method: 'GET',
                url: '/reparaciones',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    'Authorization': 'Bearer ' + access_token,
                },
            })
            console.log('reparaciones:', response.data.data);
            context.commit('reparaciones/setReparaciones', response.data.data, { root: true })
        }

    } catch (e) {
    } finally {
        context.commit('setLoading', false, { root: true })
    }
}


export async function crearReparacion(context, [access_token, modelReparacion]) {
    try {

        if (access_token) {
           // context.commit('setLoading', true, { root: true })
            const response = await Vue.axios({
                method: 'POST',
                url: '/reparaciones',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    'Authorization': 'Bearer ' + access_token,
                },
                data: modelReparacion
            })
          
           // context.commit('reservas/setDisponibilidadAnual', response.data, { root: true })
        }

    } catch (e) {
    } finally {
     //  context.commit('setLoading', false, { root: true })
    }
}

export async function updateReparacion(context, [access_token, modelReparacion]) {
    try {
        if (access_token) {
          
            const response = await Vue.axios({
                method: 'PUT',
                url: '/reparaciones/' + modelReparacion.id,
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    'Authorization': 'Bearer ' + access_token,
                },
                data: modelReparacion

            })
            if (response.status == 200) {
                context.commit('reparaciones/actListReparaciones', response.data.data, { root: true })
               }
           return response;
           // context.commit('reservas/setDisponibilidadAnual', response.data, { root: true })
        }

    } catch (e) {
    } finally {
     // context.commit('setLoading', false, { root: true })
    }
}

export async function eliminarReparacion(context, [access_token, reparacion_id]) {
    try {
        if (access_token) {
            const response = await Vue.axios({
                method: 'DELETE',
                url: '/reparaciones/' + reparacion_id,
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    'Authorization': 'Bearer ' + access_token,
                },
            })

         
           if (response.status == 200) {
            context.commit('reparaciones/actDeleteListReparaciones', reparacion_id, { root: true })
           }
           return response;
          
           // context.commit('reservas/setDisponibilidadAnual', response.data, { root: true })
        }

    } catch (e) {
    } finally {
      // context.commit('setLoading', false, { root: true })
    }
}


